import axios from 'axios'

// Single source of the Irrigation-division crew list that feeds the Property
// Review "Assigned Irrigation Tech" picker across every surface that renders it.
// Returns real { _id, name } crews (division 'Irrigation and Lighting', active,
// HMI entity) so a selected tech persists as a genuine Crew _id, not a name.
export const IRRIGATION_DIVISION = 'Irrigation and Lighting'

export async function fetchIrrigationCrews (url) {
  const res = await axios.get(`${url}/api/crews/listCrews`, {
    params: { forHMICrewsAssignment: true, division: IRRIGATION_DIVISION }
  })
  return res.data?.crews || []
}
